import { render, staticRenderFns } from "./PriceOneTheme0.vue?vue&type=template&id=a648e3e0&scoped=true"
import script from "./PriceOneTheme0.vue?vue&type=script&lang=js"
export * from "./PriceOneTheme0.vue?vue&type=script&lang=js"
import style0 from "./PriceOneTheme0.vue?vue&type=style&index=0&id=a648e3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a648e3e0",
  null
  
)

export default component.exports